
import { DateAndValueXYChartUnitEnum } from '../../enums/date-and-value-x-y-chart-unit.enum';
import { AbstractChartOptionsModel } from '../abstract-chart-options.model';

export interface CategoryValueXYChartOptions extends AbstractChartOptionsModel {
    xValueLabel: string;
    percentLabel: string;

    stacked?: boolean;
    stackType?: StackTypesEnum;
    exportLabels?: { [key: string]: any };
    categoryLabelStackedOnTop?: boolean;
    columnHeight?: number;
    includeTotalSeries?: boolean;
    reverseBarSeriesOrder?: boolean;
    reverseSourceOrder?: boolean;
    dataPointDistinctColor?: boolean;
    hideCategoryLabel?: boolean;
    useReportSeriesColor?: boolean;
    seriesColorMapKey?: string;
    smallChartDisplayLimit?: number;
    showGrid?: boolean;
    valueAxisTitle?: string;
    previousPeriodCountExportLabel?: string;
    previousPeriodPercentExportLanbel?: string;
    sharedReportChartMinHeight?: number;
    noActionOnColumnClick?: boolean;
    includeScrollbarX?: boolean;
    hideValueLabel?: boolean;
    exportLabelTotalKey?: string;
    barDisplayLimit?: number;
    showFewerItemsAtLimitedSpace?: boolean;
    // Only apply to IconBarChartModel
    imageAsCategory?: boolean;
    hidePreviousPeriod?: boolean;
    trendIndicators?: boolean;
    hideLegend?: boolean;
    appBaseHref?: string;
    tooltipHTML?: string;
    symbol?: string;
    unit?: DateAndValueXYChartUnitEnum;
    isSocialStyles?: boolean;
    categoryLabelMap?: Map<string, string>;
    legendScrollDisabled?: boolean;

    // for Domain Authority Chart
    noPercentage?: boolean;
}

export enum StackTypesEnum {
    count,
    percent
}
